export const GET_ROLES_DATA = 'GET_ROLES_DATA'
export const SET_ROLES_DATA = 'SET_ROLES_DATA'
export const SET_ROLES_ERROR = 'SET_ROLES_ERROR'
export const SET_ROLES_PROCESSING = 'SET_ROLES_PROCESSING'

export function getRolesData () {
  return {
    type: GET_ROLES_DATA,
  }
}

export function setRolesData ({ data, processing = false } = {}) {
  return {
    type: SET_ROLES_DATA,
    payload: { data, processing },
  }
}

export function setRolesError ({ error, processing = false } = {}) {
  return {
    type: SET_ROLES_ERROR,
    payload: { error, processing },
  }
}

export function setRolesProcessing ({ processing = true } = {}) {
  return {
    type: SET_ROLES_PROCESSING,
    payload: { processing },
  }
}
